import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

 // file-upload.service.ts
uploadFile(file: File, peopleId: number, documentType: string, number: string, origin: string): Observable<any> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('peopleId', peopleId.toString());
  formData.append('documentType', documentType);
  formData.append('number', number);
  formData.append('origin', origin);

  const url = `${this.apiUrl}/sicred/api/v1/file/uploadFile`;
  
  // console.log('Upload URL:', url);
  // console.log('File:', file.name, file.size, file.type);
  // console.log('PeopleId:', peopleId);
  // console.log('Environment API URL:', this.apiUrl);
  
  return this.http.post(url, formData, { withCredentials: true }).pipe(
    catchError(error => {
      // console.error('=== UPLOAD ERROR DETAILS ===');
      // console.error('Status:', error.status);
      // console.error('Message:', error.message);
      // console.error('Error:', error.error);
      // console.error('Headers:', error.headers);
      
      if (error.status === 403) {
        //console.error('FORBIDDEN: Verifique autenticação e permissões');
      } else if (error.status === 500) {
        console.error('SERVER ERROR: Verifique logs do backend');
      }
      
      return throwError(() => error);
    })
  );
}

  downloadFile(fileName: string): Observable<Blob> {
    const url = `${this.apiUrl}/sicred/api/v1/file/downloadFileByName/${fileName}`;
    return this.http.get(url, {
      responseType: 'blob'
    });
  }

  downloadFileById(peopleId: number, documentId: number): Observable<Blob> {
    const url = `${this.apiUrl}/sicred/api/v1/file/downloadFile/${peopleId}/${documentId}`;
    return this.http.get(url, {
      responseType: 'blob'
    });
  }

  openView(id: number): Observable<Blob> {
    const url = `${this.apiUrl}/sicred/api/v1/file/view/${id}`;
    return this.http.get(url, {
      responseType: 'blob'
    });
  }
}

